import { Sidebar, useSidebar } from "@/components/ui/sidebar";
import { useAdRedirect } from "@/lib/useAds";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFilteredChatMatches } from "@/hooks/queries/use-filtered-chat-matches";
import { useUrlFilter } from "@/hooks/use-url-filter";
import ChatSidebarHeader from "./chat-sidebar-header";
import ChatSidebarContent from "./chat-sidebar-content";
import { SenderFilter } from "@/types/chat";

export default function ChatSidebar() {
  const { selectedAd, adsSnapshot, navigateToAd } = useAdRedirect("/chat");
  const { id, userId } = useParams<{
    id?: string;
    userId?: string;
  }>();

  const { reviewFilter, setReviewFilter } = useUrlFilter(userId, id);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [senderFilter, setSenderFilter] = useState<SenderFilter>("all");

  //TODO: rename. activeChats? It's not chats from firebase collection, needs a good name. It is User joined with TopReciprocalMatch
  const { activeMatches, archivedMatches, isLoading, error } =
    useFilteredChatMatches(id, searchTerm, senderFilter, reviewFilter);
  console.log("🚀 ~ ChatSidebar ~ activeMatches:", activeMatches);

  const { setOpen } = useSidebar();
  useEffect(() => {
    setOpen(location.pathname.includes("chat"));
  }, [location.pathname]);

  return (
    <Sidebar collapsible="none" className="hidden md:flex flex-1 ">
      {error ? (
        <p>Error: {JSON.stringify(error)}</p>
      ) : (
        <>
          <ChatSidebarHeader
            adsSnapshot={adsSnapshot}
            navigateToAd={navigateToAd}
            selectedAd={selectedAd}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            senderFilter={senderFilter}
            setSenderFilter={setSenderFilter}
            reviewFilter={reviewFilter}
            setReviewFilter={setReviewFilter}
          />
          <ChatSidebarContent
            isLoading={isLoading}
            activeMatches={activeMatches}
            archivedMatches={archivedMatches}
            selectedAd={selectedAd}
            id={id}
          />
        </>
      )}
    </Sidebar>
  );
}
